"use client";

import Link from "next/link";
import { useEffect, useState } from "react";

function removeHTMLTags(summary: string): string {
  return summary
    .replace(/<\/?[^>]+(>|$)/g, "")
    .replace(/\s+/g, " ")
    .replace(/^\s+|\s+$/, "")
    .normalize()
    .trim();
}

function getUrl(url: string, title: string, summary: string) {
  const { hostname } = new URL(url);
  return `https://www.facebook.com/sharer.php?u=${encodeURIComponent(url)}`;
}

export default function ShareOnLinkedIn({
  title,
  summary,
}: {
  title: string;
  summary: string;
}) {
  const [url, setUrl] = useState<string>();

  useEffect(() => {
    setUrl(document.location.href);
  }, []);

  if (!url) {
    return <></>;
  }
  return (
    <Link
      href={getUrl(url, title, summary)}
      className="pt-3 flex items-center justify-end gap-1"
    >
      <span
        className="h-[20px] w-[20px] shrink-0 bg-[#121212]"
        style={{
          WebkitMaskImage: "url('/svg/share-facebook.svg')",
          maskImage: "url('/svg/share-facebook.svg')",
          WebkitMaskRepeat: "no-repeat",
          maskRepeat: "no-repeat",
          WebkitMaskPosition: "center",
          maskPosition: "center",
          WebkitMaskSize: "contain",
          maskSize: "contain",
        }}
      />
      <div className="text-[#121212] text-sm font-medium">
        Share on Facebook
      </div>
    </Link>
  );
}
